export type ProjectScope = {
    service: string
    scope: string
    timeline: string
    stack: string
}

export const scopeIntro = "Every project is different, but most fit one of these shapes. Here is roughly how each one runs, so our first call can start from something concrete."

export const projectScopes: ProjectScope[] = [
    {
        service: "Company website",
        scope: "Pages, CMS, contact forms and SEO basics",
        timeline: "2 to 4 weeks",
        stack: "WordPress or Next.js"
    },
    {
        service: "Web application",
        scope: "Dashboards, ticketing, bookings and admin tools",
        timeline: "6 to 12 weeks",
        stack: "Next.js, Node.js"
    },
    {
        service: "WebGIS",
        scope: "Interactive maps, spatial data cleanup and asset tracking",
        timeline: "4 to 10 weeks",
        stack: "ArcGIS Pro, web maps"
    },
    {
        service: "Mobile app",
        scope: "Cross-platform apps with real-time features",
        timeline: "8 to 14 weeks",
        stack: "React Native"
    }
]
